import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/header/mspc_close_small.png'


const _withScopeId = n => (_pushScopeId("data-v-205ccc43"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mask"
}
const _hoisted_2 = { class: "dialogContent" }
const _hoisted_3 = {
  key: 0,
  class: "loginContent"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "更换喵手AI手机号")
], -1))
const _hoisted_5 = { class: "operationMiddle" }
const _hoisted_6 = { class: "codeItem" }
const _hoisted_7 = { class: "operationBtn" }
const _hoisted_8 = {
  key: 1,
  class: "loginContent"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "重置密码")
], -1))
const _hoisted_10 = { class: "operationMiddle" }
const _hoisted_11 = { class: "operationBtn" }
const _hoisted_12 = {
  key: 2,
  class: "loginContent"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "注册喵手AI账号")
], -1))
const _hoisted_14 = { class: "operationMiddle" }
const _hoisted_15 = { class: "codeItem" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "userAgreement" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "titleLabel" }, "注册表明你已同意"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://miaoshouai.com/private/article_member.html",
    target: "_blank",
    class: "valueLabel"
  }, "《用户协议》"),
  /*#__PURE__*/_createElementVNode("span", null, "和"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://miaoshouai.com/private/article_private.html",
    target: "_blank",
    class: "valueLabel"
  }, "《隐私政策》")
], -1))
const _hoisted_17 = { class: "operationBtn" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已有账号？登录", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 3,
  class: "loginContent"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "登录")
], -1))
const _hoisted_22 = { class: "operationMiddle" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "忘记密码？", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "operationBtn" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "注册账号", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 4,
  class: "loginContent"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "忘记密码")
], -1))
const _hoisted_30 = { class: "operationMiddle" }
const _hoisted_31 = { class: "operationBtn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "closeBtn",
            src: _imports_0,
            alt: "",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)))
          }),
          (_ctx.type == 'updatePhone')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.webRegisterReq.phoneNumber) = $event)),
                    placeholder: "手机号",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.phoneNumber,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.webRegisterReq.verificationCode) = $event)),
                      placeholder: "短信验证码",
                      class: "showInput"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.webRegisterReq.verificationCode,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("p", {
                      class: "codeLabel",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getCode && _ctx.getCode(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.codeLoadingText), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updatePhone && _ctx.updatePhone(...args)))
                  }, "更新")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'reset')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    readonly: "",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.webRegisterReq.email) = $event)),
                    placeholder: "邮箱验证码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.email,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.webRegisterReq.code) = $event)),
                    placeholder: "邮箱验证码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.code,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.webRegisterReq.passWord) = $event)),
                    placeholder: "密码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.passWord,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.webRegisterReq.replyPassWord) = $event)),
                    placeholder: "确认密码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.replyPassWord,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetPwd && _ctx.resetPwd(...args)))
                  }, "重置密码")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'register')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.webRegisterReq.email) = $event)),
                    placeholder: "电子邮箱",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.email,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.webRegisterReq.userName) = $event)),
                    placeholder: "昵称",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.userName,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.webRegisterReq.phoneNumber) = $event)),
                    placeholder: "手机号",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.phoneNumber,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.webRegisterReq.verificationCode) = $event)),
                      placeholder: "短信验证码",
                      class: "showInput"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.webRegisterReq.verificationCode,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("p", {
                      class: "codeLabel",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.getCode && _ctx.getCode(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.codeLoadingText), 1)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.webRegisterReq.passWord) = $event)),
                    placeholder: "密码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.passWord,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.webRegisterReq.replyPassWord) = $event)),
                    placeholder: "确认密码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.replyPassWord,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _hoisted_16
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.getRegister && _ctx.getRegister(...args)))
                  }, "注册"),
                  _createElementVNode("p", {
                    class: "registerBtn",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleType('login')))
                  }, _hoisted_19)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'login')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.webRegisterReq.email) = $event)),
                    placeholder: "电子邮箱",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.email,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.webRegisterReq.passWord) = $event)),
                    placeholder: "密码",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.passWord,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("p", {
                    class: "forgetBtn",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleType('forget')))
                  }, _hoisted_24)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.getLogin && _ctx.getLogin(...args)))
                  }, "登录"),
                  _createElementVNode("p", {
                    class: "registerBtn",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleType('register')))
                  }, _hoisted_27)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'forget')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.webRegisterReq.email) = $event)),
                    placeholder: "邮箱",
                    class: "showInput"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.webRegisterReq.email,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
                  }, "发送验证链接至邮箱")
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}